import React from "react";
// import Layout from "../../components/layout/layout";
import DashboardProfile from "../../components/dashboard/dashprofile";
import "./dashboard.css";
import DeveloperStad from "../../components/dashboard/developerstad";
import MyProject from "../../components/dashboard/dashproject";
// import DashPlan from "../../components/dashboard/dashplan";

const Dashboard = () => {
  return (
    // <Layout>
    <div className='dashbord-content'>
      <DashboardProfile />
      <div className='dashboard-content-container'>
        <DeveloperStad />
        <MyProject />
        {/* <DashPlan /> */}
      </div>
    </div>
    // </Layout>
  );
};

export default Dashboard;
